import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";

import {
  Models,
  Academy,
  ColorPalettes,
  Fonts,
  Home,
  HowItWorks,
  InteriorDesign,
  Stickers,
  Start,
  ToolLanding,
  // About,
  // Assets,
  // BecomeAMember,
  // Difference,
  // ExclusiveTools,
  // GetAccess,
  // LookingFor,
} from "./pages";
import "./index.css";
import { Layout } from "./components";
import { useEffect, useRef } from "react";
import { initMetaPixel, trackPageView } from "./helpers/metaPixel";
import { analytics } from "./helpers/analytics";
import { Seo } from "./components/Seo";

const RouteTracker = () => {
  const location = useLocation();
  const isFirstPageView = useRef(true);

  useEffect(() => {
    analytics.page({
      route: location.pathname,
      query: location.search || undefined,
    });

    if (isFirstPageView.current) {
      isFirstPageView.current = false;
      return;
    }

    trackPageView();
  }, [location.pathname, location.search]);

  return null;
};

const App = () => {
  useEffect(() => {
    analytics.init();
    initMetaPixel();
  }, []);

  return (
    <div className="app">
      <BrowserRouter>
        <Seo />
        <RouteTracker />
        <Routes>
          {/* Web2app quiz funnel — standalone, no Layout/header */}
          <Route path="/start" element={<Start />} />
          <Route path="/start/subscription-activated" element={<Start />} />
          <Route path="/start/trial-activated" element={<Start />} />
          <Route path="*" element={<MainRoutes />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

const MainRoutes = () => {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
            <Route path="academy" element={<Academy />} />
            <Route path="color-palettes" element={<ColorPalettes />} />
            <Route path="3d-models" element={<Models />} />
            <Route path="fonts" element={<Fonts />} />
            <Route path="how-it-works" element={<HowItWorks />} />
            <Route path="interior-design" element={<InteriorDesign />} />
            <Route path="stickers" element={<Stickers />} />
            <Route path="tools/:slug" element={<ToolLanding />} />

            <Route path="/redirect-google" element={<Home />} />
            <Route path="academy/redirect-google" element={<Academy />} />
            <Route
              path="color-palettes/redirect-google"
              element={<ColorPalettes />}
            />
            <Route path="3d-models/redirect-google" element={<Models />} />
            <Route path="fonts/redirect-google" element={<Fonts />} />
            <Route
              path="how-it-works/redirect-google"
              element={<HowItWorks />}
            />
            <Route
              path="interior-design/redirect-google"
              element={<InteriorDesign />}
            />
            <Route path="stickers/redirect-google" element={<Stickers />} />
            <Route path="/redirect-apple" element={<Home />} />

            <Route path="academy/redirect-apple" element={<Academy />} />
            <Route
              path="color-palettes/redirect-apple"
              element={<ColorPalettes />}
            />
            <Route path="3d-models/redirect-apple" element={<Models />} />
            <Route path="fonts/redirect-apple" element={<Fonts />} />
            <Route
              path="how-it-works/redirect-apple"
              element={<HowItWorks />}
            />
            <Route
              path="interior-design/redirect-apple"
              element={<InteriorDesign />}
            />
            <Route path="stickers/redirect-apple" element={<Stickers />} />

            <Route path="/subscription-activated" element={<Home />} />
            <Route
              path="academy/subscription-activated"
              element={<Academy />}
            />
            <Route
              path="color-palettes/subscription-activated"
              element={<ColorPalettes />}
            />
            <Route
              path="3d-models/subscription-activated"
              element={<Models />}
            />
            <Route path="fonts/subscription-activated" element={<Fonts />} />
            <Route
              path="how-it-works/subscription-activated"
              element={<HowItWorks />}
            />
            <Route
              path="interior-design/subscription-activated"
              element={<InteriorDesign />}
            />
            <Route
              path="stickers/subscription-activated"
              element={<Stickers />}
            />

            <Route path="/trial-activated" element={<Home />} />
            <Route path="academy/trial-activated" element={<Academy />} />
            <Route
              path="color-palettes/trial-activated"
              element={<ColorPalettes />}
            />
            <Route path="3d-models/trial-activated" element={<Models />} />
            <Route path="fonts/trial-activated" element={<Fonts />} />
            <Route
              path="how-it-works/trial-activated"
              element={<HowItWorks />}
            />
            <Route
              path="interior-design/trial-activated"
              element={<InteriorDesign />}
            />
            <Route path="stickers/trial-activated" element={<Stickers />} />

            {/* <Route path="onboarding/about" element={<About />} />
            <Route path="onboarding/assets" element={<Assets />} />
            <Route
              path="onboarding/become-a-member"
              element={<BecomeAMember />}
            />
            <Route path="onboarding/difference" element={<Difference />} />
            <Route
              path="onboarding/exclusive-tools"
              element={<ExclusiveTools />}
            />
            <Route path="onboarding/get-access" element={<GetAccess />} />
            <Route path="onboarding/looking-for" element={<LookingFor />} /> */}
      </Routes>
    </Layout>
  );
};

export default App;
